// extracted by mini-css-extract-plugin
export default {"container":"Lesson_container__o3-7t","headerTitle":"Lesson_headerTitle__BTX0K","columns":"Lesson_columns__BFtjs","column":"Lesson_column__BrPrC","title":"Lesson_title__iUBJL"};